<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">Приложение 7</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="table-container">
            <table class="table b-table table-bordered b-table-no-border-collapse">
                <thead>
                <tr>
                    <th v-for="(header, i) in tableHeaders"
                        :key="i"
                        :rowspan="header.rowspan"
                        :colspan="header.colspan"
                        class="text-center"
                        style="white-space: pre-line;">
                        {{ header.label }}
                    </th>
                </tr>
                <tr>
                    <th v-for="(sub, j) in subHeaders" class="text-center" :key="'sub-' + j">{{ sub }}</th>
                </tr>
                <tr>
                    <th v-for="n in 10" :key="'num-' + n" class="text-center">{{ n }}</th>
                </tr>
                </thead>
                <tbody v-for="(row, index) in formApp7" :key="index">
                <tr class="text-right">
                    <td>{{ row.code }}</td>
                    <td>{{ row.name_ru }}</td>
                    <td><input type="number" v-model.number="row.column3"
                               @blur="blurInput(row, 'column3')"
                               @keydown="blockInvalidKeys($event)"
                               :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                               :disabled="access_level === 1 || !actualVersion"
                               class="form-control no-spinner" style="text-align: right;" step="0.1" /></td>
                    <td><input type="number" v-model.number="row.column4"
                               @blur="blurInput(row, 'column4')"
                               @keydown="blockInvalidKeys($event)"
                               :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                               :disabled="access_level === 1 || !actualVersion"
                               class="form-control no-spinner" style="text-align: right;" step="0.1" /></td>
                    <td><input type="number" v-model.number="row.column5"
                               @blur="blurInput(row, 'column5')"
                               @keydown="blockInvalidKeys($event)"
                               :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                               :disabled="access_level === 1 || !actualVersion"
                               class="form-control no-spinner" style="text-align: right;" step="0.1" /></td>
                    <td><input type="number" v-model.number="row.column6"
                               @blur="blurInput(row, 'column6')"
                               @keydown="blockInvalidKeys($event)"
                               :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                               :disabled="access_level === 1 || !actualVersion"
                               class="form-control no-spinner" style="text-align: right;" step="0.1" /></td>
                    <td><input type="number" v-model.number="row.column7"
                               @blur="blurInput(row, 'column7')"
                               :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                               :disabled="access_level === 1 || !actualVersion"
                               class="form-control no-spinner" style="text-align: right;" step="0.1" /></td>
                    <td>{{$n(row.column8)}}</td>
                    <td><input type="number" v-model.number="row.column9"
                               @blur="blurInput(row, 'column9')"
                               @keydown="blockInvalidKeys($event)"
                               :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                               :disabled="access_level === 1 || !actualVersion"
                               class="form-control no-spinner" style="text-align: right;" step="0.1" /></td>
                    <td><input type="number" v-model.number="row.column10"
                               @blur="blurInput(row, 'column10')"
                               @keydown="blockInvalidKeys($event)"
                               :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                               :disabled="access_level === 1 || !actualVersion"
                               class="form-control no-spinner" style="text-align: right;" step="0.1" /></td>
                </tr>
                </tbody>
                <tfoot>
                <tr class="text-right font-weight-bold" style="font-size: 15px">
                    <td></td>
                    <td>Итого</td>
                    <td>{{ $n(totalRow.column3) || '' }}</td>
                    <td>{{ $n(totalRow.column4) || '' }}</td>
                    <td>{{ $n(totalRow.column5) || '' }}</td>
                    <td>{{ $n(totalRow.column6) || '' }}</td>
                    <td>{{ $n(totalRow.column7) || '' }}</td>
                    <td>{{ $n(totalRow.column8) || '' }}</td>
                    <td>{{ $n(totalRow.column9) || '' }}</td>
                    <td><span
                        v-if="hasError"
                        :title="'Значение не соответствует контролю: строка «Итого», Форма Приложение 7 = строка 070 + 080, Форма Таблица 1.3 ПД-МБ'"
                        class="warning-icon"
                    >⚠</span>{{ $n(totalRow.column7) || '' }}
                    </td>
                </tr>
                </tfoot>
            </table>
            <loading
                :active="loading"
                is-full-screen
                spinner="bar-fade-scale"
                color="#6495ED"
            />
        </div>
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import {Ax} from "@/utils";
import moment from "moment";

export default {
    name: 'forecast-uo-app7',
    components: {'loading': VueElementLoading},
    props: {
        year: Number,
        region: String,
        version: String,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        access_level: Number,
        showInc: Boolean,
        table_num: String,
        radio_year: Number,
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            open: false,
            subHeaders: [
                'из областного бюджета, города республиканского значения, столицы',
                'из других источников',
                'начислено',
                'к выплате'
            ],
            formApp7: [],
            openRows: {},
            inputValues: [],
            showModal: false,
            filteredComments: [],
            comments_text: '',
            totalRow: {
                column2: 0,
                column3: 0,
                column4: 0,
                column5: 0,
                column6: 0,
                column7: 0,
                column8: 0,
                column9: 0,
                column10: 0,
            },
        }
    },
    async mounted() {
        await this.loadApp7(this.radio_year);
    },
    computed: {
        forecastProps() {
            return {
                year: this.year,
                region: this.region,
                region_name: this.region_name,
                version: this.version,
                version_name: this.version_name,
                dataType: this.dataType,
                obl: this.obl,
                actualVersion: this.actualVersion,
                access_level: this.access_level,
                radio_year: this.radio_year
            };
        },
        tableHeaders() {
            return [
                { label: '№', rowspan: 2 },
                { label: 'Наименование показателей', rowspan: 2 },
                { label: 'Долг на начало периода', rowspan: 2 },
                { label: 'Поступление займов', rowspan: 2 },
                { label: 'Погашение долга', colspan: 2 },
                { label: 'Корректировки', rowspan: 2 },
                { label: 'Долг на конец периода \n(графа 3 + графа 4 - графа 5 - графа 6 + графа 7)', rowspan: 2 },
                { label: `Сумма вознаграждения за ${this.radio_year} год`, colspan: 2 }
            ]
        }
    },
    watch: {
        radio_year() {
            this.inputValues = [];
        }
    },
    methods: {
        hasError() {
            return this.checkDataList.find(item => {
                if (item.checked_form !== 'PR7') return false;

                // проверяем все возможные поля
                const fieldMap = {
                    evaluation: this.year - 1,
                    forecast_1: this.year,
                    forecast_2: this.year + 1,
                    forecast_3: this.year + 2,
                };

                // ищем, есть ли совпадение
                return Object.entries(fieldMap).some(([field, year]) => {
                    return item[field] && year === this.radio_year;
                });
            });
        },
        blockInvalidKeys(event) {
            if (['e', 'E', '+', '-'].includes(event.key)) {
                event.preventDefault();
            }
        },
        blurInput(child, data) {
            let parsedValue;
            if (child[data] === undefined || child[data] === null || child[data] === "") {
                parsedValue = null;
            } else {
                parsedValue = parseFloat(child[data]) || 0;
            }
            child[data] = parsedValue;

            const existingEntryIndex = this.inputValues.findIndex(entry => entry.code === child.code);
            if (existingEntryIndex !== -1) {
                // Update the specific field for an existing entry
                this.$set(this.inputValues[existingEntryIndex], data, parsedValue);
            } else if (parsedValue !== null) {
                // Create a new entry if it doesn't exist and the value is not null
                const newEntry = {
                    code: child.code,
                    column3: data === 'column3' ? parsedValue : null,
                    column4: data === 'column4' ? parsedValue : null,
                    column5: data === 'column5' ? parsedValue : null,
                    column6: data === 'column6' ? parsedValue : null,
                    column7: data === 'column7' ? parsedValue : null,
                    column9: data === 'column9' ? parsedValue : null,
                    column10: data === 'column10' ? parsedValue : null,
                };
                this.inputValues.push(newEntry);
            }

            const sumField = (rows, field) =>
                this.toNum(rows.reduce((acc, row) => acc + (parseFloat(row[field]) || 0), 0));

            const setSums = (target, rows, fields) => {
                this.$set(target, fields, sumField(rows, fields));
            };

            const totalArray = this.formApp7;
            setSums(this.totalRow, totalArray, data);

            if (['column3', 'column4', 'column5', 'column6', 'column7'].includes(data)) {
                const col3 = parseFloat(child.column3) || 0;
                const col4 = parseFloat(child.column4) || 0;
                const col5 = parseFloat(child.column5) || 0;
                const col6 = parseFloat(child.column6) || 0;
                const col7 = parseFloat(child.column7) || 0;

                const newCol8 = col3 + col4 - col5 - col6 + col7;

                this.$set(child, 'column8', this.toNum(newCol8));
                setSums(this.totalRow, totalArray, 'column8');
            }
        },
        async loadApp7(year) {
            this.totalRow = {column3: 0, column4: 0, column5: 0, column6: 0, column7: 0, column8: 0, column9: 0, column10: 0};
            try {
                const response = await fetch('/api-py/get_pkfo_mb_loans/' + this.version + '/' + year + '/' + this.year);
                this.formApp7 = await response.json();

                this.$nextTick(() => {
                    if (this.formApp7 && this.formApp7.length) {
                        this.formApp7.forEach(row => {
                            ['column3', 'column4', 'column5', 'column6', 'column7', 'column9', 'column10'].forEach(col => {
                                if (row[col] !== undefined && row[col] !== null && row[col] !== '') {
                                    this.blurInput(row, col);
                                }
                            });
                        });
                    }
                });
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки данных', error.toString());
            }
        },
        async SaveData() {
            if (this.inputValues.length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'code_form', 'PR7');
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'radio_year', this.radio_year);
                this.$set(item, 'pkfo_type', 'uo');
                this.$set(item, 'data_type', this.dataType);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_mb_loans', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else if (result.result === 'error') {
                        this.makeToast('danger', 'Ошибка', 'Ошибка сохранения данных.');
                    } else {
                        this.makeToast('warning', 'Внимание', 'Неизвестный ответ от сервера.');
                    }
                } catch (e) {
                    this.makeToast('danger', 'Ошибка', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }

        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.radio_year, cur_year: this.year, region: this.region, version: this.version, data_type: this.dataType, reg_name: this.region_name, ver_name: this.version_name };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_uo_download_app7/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Приложение 7.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        toNum(value, fix = 1) {
            if (typeof (value) === 'string') {
                return parseFloat(parseFloat(value).toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
    }
}
</script>
